import jwtDecode, { JwtPayload } from 'jwt-decode'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Toast, { ToastType } from '../../../../utils/toast'
import { MenuComponent } from '../../../../_metronic/assets/ts/components'
import { getAuth } from './AuthHelpers'
import { useRefetchAccessToken } from './_requests'

const AuthVerify = (props: any) => {
  let location = useLocation()
  const { refetch } = useRefetchAccessToken(true)
  useEffect(() => {
    MenuComponent.reinitialization()
    const auth = getAuth()!
    const jwt = jwtDecode<JwtPayload>(auth)
    if (jwt === undefined || jwt.exp! * 1000 < Date.now()) {
      // props.logout()
      refetch();
      // Toast('Session Expired', ToastType.error)
    }
  }, [location])
  return <></>
}

export default AuthVerify
